import { BadRequest, ServiceUnavailable } from 'common/errors'
import { useState } from 'react'
import { twoFactorAuth } from '../api/website-public-page-api'
import { PublicPageFieldSlugEnum } from '../enums/public-page-field-slug-enum'
import { validateEmptyField } from '../utils/validation'

type ErrorFields = Partial<Record<PublicPageFieldSlugEnum | 'root', string[]>>

export const useTwoFactorAuthSubmit = () => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<ErrorFields>()
  const [authCode, setAuthCode] = useState('')
  const [trusted, setTrusted] = useState(false)

  const setAuthCodeValue = (value: string) => {
    setAuthCode(value)
    if (errors?.[PublicPageFieldSlugEnum.TwoFactorAuthCode]) {
      setErrors(undefined)
    }
  }

  const handleSubmit = async () => {
    const authCodeEmptyError = validateEmptyField(authCode)
    if (authCodeEmptyError && authCodeEmptyError.length > 0) {
      setErrors({
        [PublicPageFieldSlugEnum.TwoFactorAuthCode]: authCodeEmptyError,
      })
      return
    }

    setErrors(undefined)
    try {
      setLoading(true)
      const response = await twoFactorAuth({ authCode, trusted })
      const responseUrl = (response.request as { responseURL?: string })
        ?.responseURL
      const redirect = response.data?.redirect
      if (redirect) {
        window.location.replace(redirect)
        return
      }
      if (responseUrl) {
        window.location.replace(responseUrl)
      }
    } catch (e) {
      if (e instanceof ServiceUnavailable) {
        setErrors({ root: ['core.errors.service_temporary_unavailable'] })
      } else if (e instanceof BadRequest) {
        const { fields, common } = e.response?.data?.errors || {}

        const newErrors: ErrorFields = {}
        if (fields) {
          Object.entries(fields).forEach(([key, messages]) => {
            if (key === 'authCode' || key === '_auth_code') {
              newErrors[PublicPageFieldSlugEnum.TwoFactorAuthCode] = [
                messages?.join('\n'),
              ]
            }
          })
        }
        if (common) {
          newErrors.root = [common?.join('\n')]
        }
        setErrors(newErrors)
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    errors,
    authCode,
    setAuthCode: setAuthCodeValue,
    trusted,
    setTrusted,
    handleSubmit,
  }
}
